import React, { useEffect, useState } from "react";
// import * as APIHelper from '../../Helper/mockAPIFetch';
import * as APIHelper from '../../Helper/apiFetch';
import { useNavigate } from 'react-router-dom';
import RenderTimer from "./RenderTimer";
import UserPrediction from "./UserPrediction";
import VS from '../../images/VS.png';
import predictCheck from '../../images/Checkbox.png';
import predictWrong from '../../images/cancel.png';
import sats from '../../images/sats.png';
import { MdLockOutline } from "react-icons/md";
import { MdOutlineCardGiftcard } from "react-icons/md";
import { Spinner } from "react-bootstrap";
import { HiCheckCircle } from "react-icons/hi";
import Congratulation from "../congratulation";

const initiaData = require('../urlEncodeTest.json');

const Predict = ({ cardIssued, cardPaymentStatus }) => {
    const [shimmeLoader, setShimmer] = useState(false);
    const [listTeam, setListTeam] = useState([]);
    const [matchStatuses, setMatchStatuses] = useState({});
    const [userChoices, setUserChoices] = useState({});
    const [selectedTeams, setSelectedTeams] = useState({});
    const [loadingMatches, setLoadingMatches] = useState([]);
    const [congratsPopup, setCongratsPopup] = useState(false)
    const [congratsTitle, setCongratsTitle] = useState(initiaData.congratulations);
    const [claimedRewardType, setClaimedRewardType] = useState(null);

    const navigate = useNavigate();
    useEffect(() => {
        const fetchMatchData = async () => {
            setShimmer(true);
            try {
                const resData = await APIHelper.predictGetChoice();
                setShimmer(false);
                if (resData.error) {
                    navigate('/error');
                    return;
                }
                const currentDate = Date.now();
                const updatedMatchStatuses = {};
                const updatedUserChoices = {};

                resData.forEach(match => {
                    const matchDate = new Date(match.date).getTime();

                    if (match.result) {
                        updatedMatchStatuses[match.id] = "ended";
                    } else if (matchDate <= currentDate) {
                        updatedMatchStatuses[match.id] = "started";
                    } else {
                        updatedMatchStatuses[match.id] = "notstarted";
                    }

                    updatedUserChoices[match.id] = match.userPrediction.choice;
                });

                setListTeam(resData);
                setMatchStatuses(updatedMatchStatuses);
                setUserChoices(updatedUserChoices);
            } catch (error) {
                console.error("Error fetching match data: ", error);
            }
        };

        fetchMatchData();
    }, [navigate]);

    const shimmer = [
        {
            rows: 1,
            width: '100%',
            height: 60,
            width2: '100%',
            height2: 50,
            rows2: 1,
            width3: 120,
            height3: 105,
            height4: 20,
            width4: '100%'
        }
    ]

    const shimerLoader = () => {
        return (shimmer?.map((data, index) => {
            return (
                <div style={{ height: '380px', width: 'auto', padding: '0px', margin: '0px 20px 30px 20px' }} className="matchContainer" key={index}>
                    <div className="shimmer-effect">
                    </div>
                </div>
            )
        }
        ))
    }

    const handleMatchStatusChange = (matchId, status) => {
        setMatchStatuses(prevStatuses => ({
            ...prevStatuses,
            [matchId]: status
        }));
    };

    const handleTeamSelect = (index, matchId) => {
        setSelectedTeams(prevSelectedTeams => ({
            ...prevSelectedTeams,
            [matchId]: index + 1
        }));
        /* setUserChoices(prevSelectedTeams => ({
            ...prevSelectedTeams,
            [matchId]: index + 1
        })); */
        // console.log("User selected team:", index + 1, "from match:", matchId);
    };

    const handelConfirmTeam = async (matchId, selectedTeam) => {
        try {
            setLoadingMatches(prevLoadingMatches => ({ ...prevLoadingMatches, [matchId]: true })); // Set loader to true for this match
            const resp = await APIHelper.predictPickChoice(matchId, selectedTeam);
            if (resp.error) {
                navigate('/error');
                return;
            }
            setListTeam(matches => {
                return matches.map(match => {
                    if (match.id === matchId) {
                        return {
                            ...match,
                            userPrediction: {
                                ...match.userPrediction,
                                choice: selectedTeam
                            },
                            predictions: resp.predictions
                        };
                    }
                    return match;
                });
            });
            setUserChoices(prevUserChoices => ({ ...prevUserChoices, [matchId]: selectedTeam }));
        } catch (e) {
            console.log("Error", e);
        } finally {
            setLoadingMatches(prevLoadingMatches => ({ ...prevLoadingMatches, [matchId]: false })); // Remove the match ID from loadingMatches after API response
        }
    };

    const handelClaimReward = async (matchId) => {
        try {
            await APIHelper.claimReward(matchId).then(resp => {
                if (resp.error) {
                    navigate('/error');
                }
                setCongratsPopup(true);
                /* setListTeam(matches => {
                    const currentMatch = matches[current];
                    resp.reward.status = 2;
                    currentMatch.userPrediction['rewards'] = resp.reward;
                    currentMatch.rewardsEnabled = false;
                    return matches;
                }) */
                setCongratsTitle(() => {
                    if (resp.matchResult === 3)
                        return initiaData.streak.CongratsPopupDrawMatch;

                    const base = initiaData.congratulations;
                    const type = resp.reward.type;
                    const value = (type === 'card_txn_multiply_sats' || type === 'voucher_multiply_sats')
                        ? '50%'
                        : resp.reward.value;

                    const msgTemplateMap = {
                        sats: base.msg1,
                        sc: base.superCoin,
                        card_balance: base.cardBalance,
                        gold_discount_percentage: base.goldDiscountPercentage,
                        card_txn_multiply_sats: base.cardTxnMultiplySats,
                        card_txn_sats: base.cardTxnSats,
                        voucher_sats: base.voucherSats,
                        bbps_sats: base.bbpsSats,
                        satspay_sats: base.satspay_sats,
                        card_load: base.cardLoad,
                        bonus_sats: base.bonusSats,
                        bonus_sc: base.bonusSc,
                        gold_onetime: base.goldOnetime,
                        card_activate_sats: base.cardActivateSats,
                        voucher_multiply_sats: base.voucherMultiplySats,
                        elite_upgrade_discount_percentage: base.eliteUpgradeDiscountPercentage,
                    };

                    const template = msgTemplateMap[type] || base.percentageTitle;
                    const max = resp.reward.max;
                    let msg = template
                        ?.replace("$", value)
                        ?.replace("^", max ? ` up to ${max}` : "");

                    // Highlight value + reward label (e.g. "100 Sats", "10% discount", "3x extra Sats")
                    const escapedValue = String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    msg = msg?.replace(
                        new RegExp(`(${escapedValue}.+?)(?= as | on )`, 'i'),
                        (match) => `<span style="color:#FF691D;font-weight:700">${match}</span>`
                    );
                    setClaimedRewardType(type);
                    return {
                        ...base,
                        reward: value,
                        msg1: msg,
                    };
                })
            })
        } catch (e) {
            console.log("Error", e);
        }
    };

    return (
        <div className="predictContainer">
            {
                shimmeLoader ? shimerLoader() :
                    listTeam.length === 0 ?
                        <div style={{ color: "#FFFFFF",display: 'flex', justifyContent: 'center', textAlign: 'center', alignItems:'center', height: '380px', width: 'auto', padding: '0px' }} className="matchContainer">
                            There is no match today!!!...
                        </div>
                        :
                        listTeam.map((match, matchIndex) => (
                            <div className="matchContainer" key={matchIndex}>
                                <div className="matchTimerContainerImgContainer">
                                    <img src='https://assets.gosats.io/notification/2026/3/1773401976101' alt='matchBg' className='matchTimerContainerImg' />
                                    <div className="matchCountContainer">
                                        MATCH {matchIndex + 1}
                                    </div>
                                    <div className="matchStatusrContainer">
                                        <RenderTimer match={match} matchStatus={matchStatuses[match.id]} handleMatchStatusChange={handleMatchStatusChange} />
                                    </div>
                                </div>
                                <div className="predictTimerCountContainer">
                                    {/* <div className="matchCountContainer">
                                        MATCH {matchIndex + 1}
                                    </div> */}
                                    {/* <div>
                                        <RenderTimer match={match} matchStatus={matchStatuses[match.id]} handleMatchStatusChange={handleMatchStatusChange} />
                                    </div> */}
                                </div>
                                <div className="matchSubContainer">
                                    {match.teams.map((team, teamIndex) => (
                                        <React.Fragment key={teamIndex}>
                                            <div className="teamLogoContainer">
                                                <div>
                                                <div className="captainImageBg" style={{zIndex: 111, position: 'absolute'}}></div>
                                                    <div className="layoutGrid" style={{zIndex: 888, position: 'relative'}}></div>
                                                </div>
                                                <div>
                                                    <img src={team.captains} alt=" " style={{zIndex: 444, position: 'relative', marginTop: '-200px'}} className="captainsImg" />
                                                </div>
                                                <div
                                                    className="team"
                                                    style={{
                                                        border:
                                                            (userChoices[match.id] === teamIndex + 1 || selectedTeams[match.id] === teamIndex + 1)
                                                                ? "2px solid #FFCDB3"
                                                                : "none",
                                                    }}
                                                    onClick={matchStatuses[match.id] === "notstarted" && userChoices[match.id] === -1 ? () => handleTeamSelect(teamIndex, match.id) : null}
                                                >
                                                    {
                                                        <div style={{
                                                            backgroundColor: "212426",
                                                            border: "1px solid #A6A7A8",
                                                            borderRadius: "22px",
                                                            width: "20px",
                                                            height: "20px",
                                                            margin: "10px 10px 0px 100px"
                                                        }}>
                                                            {
                                                                (match?.result) ? ( // Check if the result is present
                                                                    (userChoices[match.id] !== match?.result && userChoices[match.id] === teamIndex + 1) ?
                                                                        // Show predictWrong for the user's selected team if it's wrong
                                                                        <img src={predictWrong} alt=" " style={{ width: '20px', height: '20px', margin: '-9px 0px 0px -1px' }} />
                                                                        :
                                                                        (match?.result === teamIndex + 1) ?
                                                                            // Show predictCheck for the winning team
                                                                            <img src={predictCheck} alt=" " style={{ width: '20px', height: '20px', margin: '-9px 0px 0px -1px' }} />
                                                                            :
                                                                            null
                                                                ) : (
                                                                    // If no result is present, show predictCheck for the user's selected team
                                                                    (userChoices[match.id] === teamIndex + 1 || selectedTeams[match.id] === teamIndex + 1) ?
                                                                        <img src={predictCheck} alt=" " style={{ width: '20px', height: '20px', margin: '-9px 0px 0px -1px' }} />
                                                                        :
                                                                        null
                                                                )
                                                            }
                                                        </div>
                                                    }
                                                    <img src={team.image} alt=" " className="teamFlag" />
                                                    <div className="teamTitle" >{team.name}</div>
                                                </div>
                                            </div>
                                            {teamIndex !== match.teams.length - 1 && <div key='vs' className="vs"><img className="vsImg" src={VS} alt=" " /></div>}
                                        </React.Fragment>
                                    ))}
                                </div>
                                {match.predictions && match?.userPrediction.choice !== -1 && <UserPrediction match={match} />}
                                <div style={{ textAlign: 'center', marginTop: '25px', color: '#FFFFFF' }}>
                                    <RenderPredictTitle match={match} matchStatus={matchStatuses[match.id]} listTeam={listTeam} current={matchIndex} userChoices={userChoices} />
                                </div>
                                {
                                    listTeam.length !== 0 ? 
                                        <div className="confermTeamCTA-container" style={{marginTop: '-10px'}}>
                                            {
                                                // match?.result === userChoices[match.id] ?
                                                match?.result ?
                                                    match?.result && userChoices[match.id] === -1 || match?.userPrediction?.rewards?.status === 2 || userChoices[match.id] !== match?.result ?
                                                        null
                                                        :
                                                        <ClaimButton match={match} btnDisable={false} loader={false} handelClaimReward={handelClaimReward} />
                                                    :
                                                    <RenderConfirmButton match={match} userChoices={userChoices} matchStatus={matchStatuses[match.id]} btnDisable={false} loader={loadingMatches[match.id]} handelConfirmTeam={handelConfirmTeam} selectedTeams={selectedTeams} />
                                            }
                                        </div>
                                        :
                                        null
                                }
                                {/* {match.userPrediction?.rewards?.status === 2 ?
                                    <div className='climedReward-container'>
                                        {match.userPrediction?.rewards?.type === "sats" ?
                                            <div className="rewardWonTitle">
                                                <div> You have claimed your reward! <img src={sats} width='15px' height='auto' />{match.userPrediction?.rewards?.value}</div>
                                            </div>
                                            :
                                            match.userPrediction?.rewards?.type === "sc" ?
                                            <div className="rewardWonTitle">
                                                <div> You have claimed your Super Coin reward! {match.userPrediction?.rewards?.value}</div>
                                            </div>
                                            :
                                            <div className="rewardWonTitle">
                                                <span> You’ve won <span>{match.userPrediction?.rewards?.value}</span>% extra Bitcoin reward on your next transaction.</span>
                                            </div>
                                        }
                                    </div>
                                    : null} */}
                            </div>
                        ))
            }
            <div>
                {congratsPopup && <Congratulation title={congratsTitle} rewardType={claimedRewardType} cardIssued={cardIssued} cardPaymentStatus={cardPaymentStatus} />}
            </div>
        </div>
    );
};

const RenderPredictTitle = ({ match, matchStatus, listTeam, userChoices }) => {
    if (matchStatus === "ended") {
        if (match?.result && match?.userPrediction?.rewards?.status !== 2) {
            if (match?.result === 3) {
                return (
                    <div>Your predictions has been deemed null and void, as the match was a draw.</div>
                )
            } else if (match?.result !== userChoices[match.id] && userChoices[match.id] !== -1) {
                return (
                    <div style={{ color: '#FFFFFF' }}>Unfortunately your prediction was wrong. Try again for the next match.</div>
                )
            } else if (userChoices[match.id] === -1) {
                return (
                    <div style={{ color: '#FFFFFF' }}>Oops! You missed making a prediction today. Participate in the next match and win big!</div>
                )
            } else {
                return (
                    <div>Congratulations! You predicted right and are eligible for a reward!</div>
                )
            }
        } else if (match?.rewardsEnabled === false && match?.userPrediction?.rewards?.status === 2) {
            return (
                <div>You have already claimed your reward for this match. Keep predicting to win more rewards!</div>
            )
        } else if (match.userPrediction.choice !== -1) {
            return (
                <div style={{ color: '#FFFFFF' }}>Oops! You missed making a prediction today. Participate in the next match and win big!</div>
            )
        }
        else {
            return (
                <div>This match is over! Keep predicting for more matches to & get a chance to win big!</div>
            )
        }
    } else {
        if (listTeam.length === 0) {
            return (
                <div style={{ color: "#FFFFFF" }}>
                    There is no match today!!!...
                </div>
            )
        } else if (match?.userPrediction?.choice !== -1) {
            return (
                <div style={{ color: "#FFFFFF" }}>Your choice is confirmed! Claim rewards once the match is over.</div>
            )
        } else if (matchStatus === "started") {
            return (
                <div style={{ color: "#FFFFFF" }}>Oops! The match is live and predictions are now closed. Stay tuned for the next match!</div>
            )
        } else {
            return (
                <div>Predict the winner of Bitcoin Premier League matches and stand a chance to win big!</div>
            )
        }
    }
}

const RenderConfirmButton = ({ match, matchStatus, userChoices, btnDisable, loader, handelConfirmTeam, selectedTeams }) => {

    const alreadyPredicted = userChoices[match.id] !== -1;
    const selectedTeam = selectedTeams[match.id] || -1;
    const predictionConfirmed = alreadyPredicted && selectedTeam !== -1;

    const disabled = alreadyPredicted || selectedTeam === -1 || predictionConfirmed || loader;
    let btnStyle = { background: "#1F4839", color: '#18D887', opacity: '1' };

    if (selectedTeam !== -1 && alreadyPredicted)
    btnStyle = { background: '#1F4839', color: '#18D887', opacity: '1' }
    else if (selectedTeam !== -1)
    btnStyle = { background: '#1535A8', color: '#FFFFFF', opacity:'1' }
    else if (!alreadyPredicted)
        btnStyle = null;

    let cnfText = "CONFIRM";
    if (matchStatus !== "notstarted")
        cnfText = "PREDICTION TIME IS CLOSED"

    return (
        <button className="confermTeamCTA"
            disabled={disabled}
            onClick={() => handelConfirmTeam(match.id, selectedTeam)}
            style={btnStyle}
        >
            {loader ?
                <Spinner animation="border" size="sm" style={{ color: '#FFFFF', marginTop: '6px', marginBottom: '6px' }} /> :
                <span>{alreadyPredicted ?
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <HiCheckCircle size={22} color="#18D887" /> CONFIRMED
                    </span>
                    :
                    <div>
                        {matchStatus !== "notstarted" ?
                            <span>
                                <MdLockOutline size={24} color='#A6A7A8' style={{ marginRight: '10px' }} />
                            </span>
                            :
                            null
                        }
                        {cnfText}
                    </div>}
                </span>
            }
        </button>
    );
};

const ClaimButton = ({ match, btnDisable, loader, handelClaimReward }) => {
    const [loadingMatchId, setLoadingMatchId] = useState(null);


    return (
        <button className="confermTeamCTA"
            disabled={btnDisable || loadingMatchId === match.id}
            onClick={async () => {
                setLoadingMatchId(match.id);
                try {
                    await handelClaimReward(match.id);
                } catch (error) {
                    console.error("Error claiming rewards: ", error);
                } finally {
                    setLoadingMatchId(null);
                }
            }}>
            <span>
                {loadingMatchId === match.id ?
                    <Spinner animation="border" size="sm" style={{ color: '#FFFFF', marginTop: '6px', marginBottom: '6px' }} />
                    :
                    <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 5 }}><MdOutlineCardGiftcard size={22} color='#FFFFFF' /> CLAIM REWARD</span>
                }
            </span>
        </button>
    );
};

export default Predict;